import React, { useState, useEffect } from "react"
import { Col, Input, Label, Row, Form, FormFeedback } from "reactstrap"
import Select from "react-select"
import { useDispatch, useSelector } from "react-redux"
import { useFormik } from "formik"
import * as Yup from "yup"
import { customStylesSelect } from "common/data/settings"

const screenresolution = [
  {
    label: "Low",
    value: "L",
  },
  {
    label: "Medium",
    value: "M",
  },
  {
    label: "High",
    value: "H",
  },
]
const TrackprofileForm = ({
  selectedRow,
  isEdit,
  onAddNewProfile,
  onUpdateProfile,
  handleCancel,
  toggle,
  companyid,
  addProfileSuccessCode,
  companySetting,
  loginMainCategory,
  loginsubCategory
}) => {
  const dispatch = useDispatch()
  const [filterFsubCategory, setfilterFsubCategory] = useState([])

  const { maincategoryList, subcategoryList, userData } = useSelector(
    state => ({
      maincategoryList: state?.trackprofile?.maincategorylist,
      subcategoryList: state?.trackprofile?.subCategorylist,
      userData: state?.trackprofile?.userList,
    })
  )
  
  const userid = JSON.parse(localStorage.getItem("authUser") || "{}")?.data?.id
  // Form - validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      id: selectedRow.id,
      name: isEdit ? selectedRow && selectedRow.name : "",
      workreportvalidity: isEdit
        ? selectedRow && selectedRow.workreportvalidity
        : 60,
      screenshotinterval: isEdit
        ? selectedRow && selectedRow.screenshotinterval
        : 5,
      idleinterval: isEdit ? selectedRow && selectedRow.idleinterval : 5,
      breakinterval: isEdit ? selectedRow && selectedRow.breakinterval : 10,
      capturescreen: isEdit ? selectedRow && selectedRow.capturescreen : true,
      workreport: isEdit ? selectedRow && selectedRow.workreport : true,
      syncinterval: isEdit ? selectedRow && selectedRow.syncinterval : 15,
      privatelog: isEdit ? selectedRow && selectedRow.privatelog : false,
      manualhours: isEdit ? selectedRow && selectedRow.manualhours : true,
      hourstracking: isEdit ? selectedRow && selectedRow.hourstracking : true,
      applicationtracking: isEdit
        ? selectedRow && selectedRow.applicationtracking
        : true,
      movehrs: isEdit ? selectedRow && selectedRow.movehrs : false,
      isbillable: isEdit ? selectedRow && selectedRow.isbillable : true,
      allowbreaktoactive: isEdit
        ? selectedRow && selectedRow.allowbreaktoactive
        : false,
      screenresolution: isEdit
        ? selectedRow && selectedRow.screenresolution === undefined
          ? { label: "", value: "" }
          : selectedRow.screenresolution
        : { label: "Low", value: "L" },
      mainCategory: isEdit ? selectedRow && selectedRow.mainCategory : null,
      subCategory: isEdit ? selectedRow && selectedRow.subCategory : null,
      userlist: isEdit ? selectedRow && selectedRow.userlist : null,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Profile Name"),
      workreportvalidity: Yup.number()
        .integer("Please enter a valid number")
        .required("Work report validity is required")
        .min(1, "Minimum atleast 1")
        .max(255, "Work Report Validity must be less than or equal to 255"),
      screenshotinterval: Yup.number()
        .integer("Please enter a valid number")
        .required("Screenshot interval is required")
        .min(1, "Minimum atleast 1")
        .max(255, "Screenshot Interval must be less than or equal to 255"),
      idleinterval: Yup.number()
        .integer("Please enter a valid number")
        .required("Idle Interval is required")
        .min(1, "Minimum atleast 1")
        .max(255, "Idle Interval must be less than or equal to 255"),
      breakinterval: Yup.number()
        .integer("Please enter a valid number")
        .required("Break interval is required")
        .min(1, "Minimum atleast 1")
        .max(255, "Break Interval must be less than or equal to 255"),
      syncinterval: Yup.number()
        .integer("Please enter a valid number")
        .required("Sync interval is required")
        .min(1, "Minimum atleast 1")
        .max(255, "Sync Interval must be less than or equal to 255"),
    }),

    onSubmit: values => {
      if (isEdit) {
        const updateProfile = {
          id: values.id,
          companyid: companyid,
          name: values?.name,
          screenshotinterval: values?.screenshotinterval,
          idleinterval: values?.idleinterval,
          breakinterval: values?.breakinterval,
          capturescreen: values?.capturescreen,
          workreport: values?.workreport,
          syncinterval: values?.syncinterval,
          privatelog: values?.privatelog,
          manualhours: values?.manualhours,
          hourstracking: values?.hourstracking,
          applicationtracking: values?.applicationtracking,
          movehrs: values?.movehrs,
          isbillable: values?.isbillable,
          workreportvalidity: values?.workreportvalidity,
          allowbreaktoactive: values?.allowbreaktoactive,
          screenresolution: values?.screenresolution?.value,
          modifiedby: userid,
          settingprofileassignmentlist: [
            {
              profileid: values.id,
              companyid: companyid,
              categoryid: values?.mainCategory?.value,
              subCategoryid: values?.subCategory?.value,
              userid: values?.userlist?.value,
              id: selectedRow.profileassignmentid,
            },
          ],
        }
        // update customer
        dispatch(onUpdateProfile(updateProfile, handleResponse))
      } else {
        const newProfile = {
          companyid: companyid,
          name: values?.name,
          screenshotinterval: values?.screenshotinterval,
          idleinterval: values?.idleinterval,
          breakinterval: values?.breakinterval,
          capturescreen: values?.capturescreen,
          workreport: values?.workreport,
          syncinterval: values?.syncinterval,
          privatelog: values?.privatelog,
          manualhours: values?.manualhours,
          hourstracking: values?.hourstracking,
          applicationtracking: values?.applicationtracking,
          movehrs: values?.movehrs,
          isbillable: values?.isbillable,
          workreportvalidity: values?.workreportvalidity,
          allowbreaktoactive: values?.allowbreaktoactive,
          screenresolution: values?.screenresolution?.value,
          settingprofileassignmentlist: [
            {
              companyid: companyid,
              categoryid: values?.mainCategory?.value,
              subCategoryid: values?.subCategory?.value,
              userid: values?.userlist?.value,
            },
          ],
        }
        // save new customer
        dispatch(onAddNewProfile(newProfile, handleResponse))
      }
    },
  })
  useEffect(() => {
    const filteredData = subcategoryList?.filter(
      el =>
        validation.values?.mainCategory?.id === undefined ||
        el?.categoryId === validation.values?.mainCategory?.id
    )
    setfilterFsubCategory(filteredData)
  }, [validation.values.mainCategory])

  const handlePopulateName = () => {
    const category = validation.values.mainCategory?.label || "default"
    const subcategory = validation.values.subCategory?.label || "default"
    const user = validation.values.userlist?.label || "default"
    if (category == "All" || subcategory == "All") {
      validation.setFieldValue("name", `default_default_${user}`)
    } else {
      validation.setFieldValue("name", `${category}_${subcategory}_${user}`)
    }
  }

  const handleResponse = status => {
    if (status === "SUCCESS") {
      toggle()
      validation.resetForm()
    }
  }
  useEffect(() => {
    // if (isEmpty(selectedRow.name)) {
    handlePopulateName()
    // }
  }, [
    validation.values.mainCategory,
    validation.values.subCategory,
    validation.values.userlist,
  ])

  useEffect(() => {
    if (addProfileSuccessCode === 200) {
      validation.resetForm()
    }
  }, [addProfileSuccessCode])

  return (
    <Form
      onSubmit={e => {
        e.preventDefault()
        validation.handleSubmit()
        return false
      }}
    >
      <Row form>
        <Col className="col-12 response_track_view">
          {isEdit ? (
            <div className="mb-3">
              <Label className="form-label">
                Profile Name : {validation.values?.name}
              </Label>
            </div>
          ) : (
            ""
          )}
          <Row>
            <Col sm={6} className="response_track_view">
              <div className="mb-3">
                <Label className="form-label">{companySetting.MainCategory}</Label>
                <Select
                  isClearable
                  id="mainCategory"
                  name="mainCategory"
                  placeholder={`Please Select ${companySetting.MainCategory}`}
                  value={validation.values.mainCategory}
                  onBlur={validation.handleBlur}
                  onChange={value => {
                    validation.setFieldValue("subCategory", null)
                    validation.setFieldValue("mainCategory", value)
                    // handlePopulateName();
                  }}
                  invalid={
                    validation.touched.mainCategory &&
                    validation.errors.mainCategory
                      ? true
                      : false
                  }
                  options={
                    maincategoryList?.map(el => ({
                      ...el,
                      label: el.name,
                      value: el.id,
                    }))
                  }
                  styles={customStylesSelect}
                  classNamePrefix="select2-selection"
                />
                {validation.touched.mainCategory &&
                validation.errors.mainCategory ? (
                  <FormFeedback type="invalid">
                    {validation.errors.mainCategory}
                  </FormFeedback>
                ) : null}
              </div>
              <div className="mb-3">
                <Label className="form-label">{companySetting.SubCategory}</Label>
                <Select
                  isClearable
                  id="subCategory"
                  name="subCategory"
                  placeholder={`Please Select ${companySetting.SubCategory}`}
                  value={validation.values.subCategory || ''}
                  onBlur={validation.handleBlur}
                  onChange={value => {
                    validation.setFieldValue("subCategory", value)
                    // handlePopulateName();
                  }}
                  invalid={
                    validation.touched.subCategory &&
                    validation.errors.subCategory
                      ? true
                      : false
                  }
                  options={[
                    { id: 0, name: null, value: 0, label: "All" },
                  ].concat(
                    filterFsubCategory?.map(el => ({
                      ...el,
                      label: el.name,
                      value: el.id,
                    }))
                  )}
                  styles={customStylesSelect}
                  classNamePrefix="select2-selection"
                />
                {validation.touched.subCategory &&
                validation.errors.subCategory ? (
                  <FormFeedback type="invalid">
                    {validation.errors.subCategory}
                  </FormFeedback>
                ) : null}
              </div>

              <div className="mb-3">
                <Label className="form-label">User List</Label>
                <Select
                  isClearable
                  id="userlist"
                  name="userlist"
                  placeholder="Please Select User List"
                  onBlur={validation.handleBlur}
                  value={validation.values.userlist}
                  onChange={value => {
                    validation.setFieldValue("userlist", value)
                    // handlePopulateName();
                  }}
                  invalid={
                    validation.touched.userlist && validation.errors.userlist
                      ? true
                      : false
                  }
                  options={userData?.filter((value) => value?.userName.trim() !== "").map(el => ({
                    ...el,
                    label: el.userName,
                    value: el.userId,
                  }))}
                  styles={customStylesSelect}
                  classNamePrefix="select2-selection"
                />
                {validation.touched.userlist && validation.errors.userlist ? (
                  <FormFeedback type="invalid">
                    {validation.errors.userlist}
                  </FormFeedback>
                ) : null}
              </div>
            </Col>
            <Col sm={6} className="response_track_view">
              <Row>
                <Col sm={6} className="response_track_view">
                  <div className="mb-3">
                    <Label className="form-label">Work Report Validity</Label>
                    <div className="d-flex">
                      <Input
                        name="workreportvalidity"
                        type="number"
                        pattern="[0-9\/]*"
                        style={{ maxWidth: "106px" }}
                        step={1}
                        onChange={validation.handleChange}
                        maxLength={3}
                        onBlur={validation.handleBlur}
                        value={validation.values.workreportvalidity || ""}
                        invalid={
                          validation.touched.workreportvalidity &&
                          validation.errors.workreportvalidity
                            ? true
                            : false
                        }
                      />
                      <div className="p-2">Days</div>
                    </div>
                    {validation.touched.workreportvalidity &&
                    validation.errors.workreportvalidity ? (
                      <FormFeedback type="invalid">
                        {validation.errors.workreportvalidity}
                      </FormFeedback>
                    ) : null}
                  </div>
                </Col>
                <Col sm={6} className="response_track_view">
                  <div className="mb-3">
                    <Label className="form-label">Screenshot Interval</Label>
                    <div className="d-flex">
                      <Input
                        name="screenshotinterval"
                        type="number"
                        pattern="[0-9\/]*"
                        onChange={validation.handleChange}
                        maxLength={3}
                        onBlur={validation.handleBlur}
                        value={validation.values.screenshotinterval || ""}
                        invalid={
                          validation.touched.screenshotinterval &&
                          validation.errors.screenshotinterval
                            ? true
                            : false
                        }
                      />
                      <div className="p-2">Minutes</div>
                    </div>
                    {validation.touched.screenshotinterval &&
                    validation.errors.screenshotinterval ? (
                      <FormFeedback type="invalid">
                        {validation.errors.screenshotinterval}
                      </FormFeedback>
                    ) : null}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col sm={6} className="response_track_view">
                  <div className="mb-3">
                    <Label className="form-label">Idle Interval </Label>
                    <div className="d-flex">
                      <Input
                        name="idleinterval"
                        type="number"
                        pattern="[0-9\/]*"
                        onChange={validation.handleChange}
                        maxLength={3}
                        onBlur={validation.handleBlur}
                        value={validation.values.idleinterval || ""}
                        invalid={
                          validation.touched.idleinterval &&
                          validation.errors.idleinterval
                            ? true
                            : false
                        }
                      />
                      <div className="p-2">Minutes</div>
                    </div>
                    {validation.touched.idleinterval &&
                    validation.errors.idleinterval ? (
                      <FormFeedback type="invalid">
                        {validation.errors.idleinterval}
                      </FormFeedback>
                    ) : null}
                  </div>
                </Col>
                <Col sm={6} className="response_track_view">
                  <div className="mb-3">
                    <Label className="form-label">Break Interval </Label>
                    <div className="d-flex">
                      <Input
                        name="breakinterval"
                        type="number"
                        pattern="[0-9\/]*"
                        onChange={validation.handleChange}
                        maxLength={3}
                        onBlur={validation.handleBlur}
                        value={validation.values.breakinterval || ""}
                        invalid={
                          validation.touched.breakinterval &&
                          validation.errors.breakinterval
                            ? true
                            : false
                        }
                      />
                      <div className="p-2">Minutes</div>
                    </div>
                    {validation.touched.breakinterval &&
                    validation.errors.breakinterval ? (
                      <FormFeedback type="invalid">
                        {validation.errors.breakinterval}
                      </FormFeedback>
                    ) : null}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col sm={6} className="response_track_view">
                  <div className="mb-3">
                    <Label className="form-label">Screen Resolution</Label>
                    <Select
                      // isClearable
                      id="screenresolution"
                      name="screenresolution"
                      // placeholder="Select Screen Resolution"
                      onBlur={validation.handleBlur}
                      value={validation.values?.screenresolution}
                      onChange={value => {
                        validation.setFieldValue("screenresolution", value)
                      }}
                      invalid={
                        validation.touched.screenresolution &&
                        validation.errors.screenresolution
                          ? true
                          : false
                      }
                      options={screenresolution.map(el => ({
                        ...el,
                        label: el.label,
                        value: el.value,
                      }))}
                      styles={customStylesSelect}
                      classNamePrefix="select2-selection"
                    />
                    {validation.touched.screenresolution &&
                    validation.errors.screenresolution ? (
                      <FormFeedback type="invalid">
                        {validation.errors.screenresolution}
                      </FormFeedback>
                    ) : null}
                  </div>
                </Col>
                <Col sm={6} className="response_track_view">
                  <div className="mb-3">
                    <Label className="form-label">Sync Interval </Label>
                    <div className="d-flex">
                      <Input
                        name="syncinterval"
                        type="number"
                        pattern="[0-9\/]*"
                        onChange={validation.handleChange}
                        maxLength={3}
                        onBlur={validation.handleBlur}
                        value={validation.values?.syncinterval || ""}
                        invalid={
                          validation.touched.syncinterval &&
                          validation.errors.syncinterval
                            ? true
                            : false
                        }
                      />
                      <div className="p-2">Minutes</div>
                    </div>
                    {validation.touched.syncinterval &&
                    validation.errors.syncinterval ? (
                      <FormFeedback type="invalid">
                        {validation.errors.syncinterval}
                      </FormFeedback>
                    ) : null}
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col sm={4}>
              <div className="form-check mb-3">
                <Input
                  className="form-check-input"
                  type="checkbox"
                  onChange={validation.handleChange}
                  defaultChecked={validation.values?.capturescreen}
                  id="capturescreen"
                />
                <Label className="form-check-label" htmlFor="capturescreen">
                  Capture Screen
                </Label>
              </div>
            </Col>
            <Col sm={4}>
              <div className="form-check mb-3">
                <Input
                  className="form-check-input"
                  type="checkbox"
                  onChange={validation.handleChange}
                  defaultChecked={validation.values?.hourstracking}
                  id="hourstracking"
                />
                <Label className="form-check-label" htmlFor="hourstracking">
                  Hours Tracking
                </Label>
              </div>
            </Col>
            <Col sm={4}>
              <div className="form-check mb-3">
                <Input
                  className="form-check-input"
                  type="checkbox"
                  onChange={validation.handleChange}
                  defaultChecked={validation.values?.workreport}
                  id="workreport"
                />
                <Label className="form-check-label" htmlFor="workreport">
                  Work Report
                </Label>
              </div>
            </Col>
          </Row>
          <Row>
            <Col sm={4}>
              <div className="form-check mb-3">
                <Input
                  className="form-check-input"
                  type="checkbox"
                  onChange={validation.handleChange}
                  defaultChecked={validation.values?.applicationtracking}
                  id="applicationtracking"
                />
                <Label
                  className="form-check-label"
                  htmlFor="applicationtracking"
                >
                  Application Tracking
                </Label>
              </div>
            </Col>
            <Col sm={4}>
              <div className="form-check mb-3">
                <Input
                  className="form-check-input"
                  type="checkbox"
                  onChange={validation.handleChange}
                  defaultChecked={validation.values?.privatelog}
                  id="privatelog"
                />
                <Label className="form-check-label" htmlFor="privatelog">
                  Private Log
                </Label>
              </div>
            </Col>
            <Col sm={4}>
              <div className="form-check mb-3">
                <Input
                  className="form-check-input"
                  type="checkbox"
                  onChange={validation.handleChange}
                  defaultChecked={validation.values?.movehrs}
                  id="movehrs"
                />
                <Label className="form-check-label" htmlFor="movehrs">
                  Move Hours
                </Label>
              </div>
            </Col>
          </Row>
          <Row>
            <Col sm={4}>
              <div className="form-check mb-3">
                <Input
                  className="form-check-input"
                  type="checkbox"
                  onChange={validation.handleChange}
                  defaultChecked={validation.values?.manualhours}
                  id="manualhours"
                />
                <Label className="form-check-label" htmlFor="manualhours">
                  Manual Hours
                </Label>
              </div>
            </Col>
            <Col sm={4}>
              <div className="form-check mb-3">
                <Input
                  className="form-check-input"
                  type="checkbox"
                  onChange={validation.handleChange}
                  defaultChecked={validation.values?.isbillable}
                  id="isbillable"
                />
                <Label className="form-check-label" htmlFor="isbillable">
                  Is Billable
                </Label>
              </div>
            </Col>
            <Col sm={4}>
              <div className="form-check mb-3">
                <Input
                  className="form-check-input"
                  type="checkbox"
                  onChange={validation.handleChange}
                  defaultChecked={validation.values?.allowbreaktoactive}
                  id="allowbreaktoactive"
                />
                <Label
                  className="form-check-label"
                  htmlFor="allowbreaktoactive"
                >
                  Allow Break To Active
                </Label>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <div className="text-end">
        <button type="submit" className="btn btn-primary save-customer me-2">
          Save
        </button>
        <button
          type="button"
          color="primary"
          className="btn btn-secondary"
          onClick={handleCancel}
        >
          Cancel
        </button>
      </div>
    </Form>
  )
}

export default TrackprofileForm
